/* ── Two-panel root ───────────────────────────────────────── */
.dashRoot {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.dashContent {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: var(--sp-8);
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
}

/* ── Right chat panel ─────────────────────────────────────── */
.chatSide {
  width: 340px;
  flex-shrink: 0;
  border-left: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--color-surface);
}

.chatSideHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--sp-4);
  height: 44px;
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.chatSideTitle {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.chatSideLink {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-sky-dim);
  text-decoration: none;
  transition: color 0.15s;
}
.chatSideLink:hover { color: var(--color-sky); }

/* ── Header ───────────────────────────────────────────────── */
.header { display: flex; align-items: flex-start; justify-content: space-between; gap: var(--sp-6); }
.headerActions { display: flex; align-items: center; gap: var(--sp-2); flex-shrink: 0; }
.greeting { font-family: var(--font-mono); font-size: 22px; font-weight: 700; letter-spacing: 0.5px; }
.subGreeting { display: flex; align-items: center; gap: var(--sp-2); margin-top: var(--sp-1); font-size: 12px; }
.org     { font-family: var(--font-mono); color: var(--color-sky-dim); }
.dot     { color: var(--color-border-med); }
.dateStr { font-family: var(--font-mono); color: var(--color-text-faint); }

.printBtn {
  font-family: var(--font-mono); font-size: 11px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-muted); cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}
.printBtn:hover { border-color: var(--color-border-med); color: var(--color-text); }

.editToggle {
  font-family: var(--font-mono); font-size: 11px; font-weight: 600;
  padding: var(--sp-2) var(--sp-4); border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-muted); cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
  flex-shrink: 0;
}
.editToggle:hover { border-color: var(--color-border-med); color: var(--color-text); }
.editToggleOn {
  background: rgba(56,189,248,0.08); border-color: rgba(56,189,248,0.3);
  color: var(--color-sky);
}

/* ── Section tabs ─────────────────────────────────────────── */
.sectionTabs {
  display: flex;
  align-items: center;
  gap: 2px;
  border-bottom: 1px solid var(--color-border);
  padding-bottom: 0;
  flex-wrap: wrap;
}

.sectionTab {
  display: flex;
  align-items: center;
  gap: 4px;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  padding: 0 2px;
}

.sectionTabActive {
  border-bottom-color: var(--color-sky);
}

.sectionTabBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--color-text-faint);
  cursor: pointer;
  transition: color 0.12s;
  white-space: nowrap;
}
.sectionTabActive .sectionTabBtn { color: var(--color-sky); }
.sectionTabBtn:hover { color: var(--color-text-muted); }

.sectionTabInput {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 6px 8px;
  background: var(--color-surface);
  border: 1px solid var(--color-sky);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  outline: none;
  width: 120px;
}

.sectionTabDel {
  font-size: 9px;
  padding: 1px 4px;
  background: transparent;
  border: none;
  color: var(--color-text-faint);
  cursor: pointer;
  border-radius: 3px;
  transition: color 0.12s, background 0.12s;
}
.sectionTabDel:hover { color: var(--color-error); background: rgba(239,68,68,0.08); }

.addSectionBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  padding: 6px 10px;
  margin-left: 4px;
  background: transparent;
  border: 1px dashed var(--color-border);
  border-radius: var(--radius-sm);
  color: var(--color-text-faint);
  cursor: pointer;
  transition: border-color 0.12s, color 0.12s;
  white-space: nowrap;
}
.addSectionBtn:hover { border-color: var(--color-sky); color: var(--color-sky); }

.newSectionInput {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  padding: 5px 8px;
  margin-left: 4px;
  background: var(--color-surface);
  border: 1px solid var(--color-sky);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  outline: none;
  width: 140px;
}

/* ── Move-to dropdown ─────────────────────────────────────── */
.moveWrap { position: relative; }

.moveBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.06);
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky-dim);
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s;
}
.moveBtn:hover { background: rgba(56,189,248,0.14); }

.moveMenu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-md);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  min-width: 140px;
  z-index: 100;
  overflow: hidden;
}

.moveMenuItem {
  display: block;
  width: 100%;
  text-align: left;
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.1s, color 0.1s;
}
.moveMenuItem:hover { background: rgba(56,189,248,0.08); color: var(--color-sky); }

/* ── Section content ──────────────────────────────────────── */
.section { display: flex; flex-direction: column; gap: var(--sp-4); }
.sectionRow { display: flex; align-items: center; justify-content: space-between; }
.sectionLabel {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  letter-spacing: 2px; text-transform: uppercase; color: var(--color-text-muted);
}

/* ── Metric cards ─────────────────────────────────────────── */
.metricGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: var(--sp-4);
}

.metricCard {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.metricCard:hover { border-color: var(--color-border-med); box-shadow: var(--shadow-glow); }

.metricTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
}

.metricCardLabel {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}

.metricUnit {
  font-family: var(--font-mono);
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 3px;
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky-dim);
  flex-shrink: 0;
}

.metricValue {
  font-family: var(--font-mono);
  font-size: 26px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.5px;
  line-height: 1.1;
}

.metricValueEmpty {
  font-size: 20px;
  color: var(--color-text-faint);
}

.metricDesc {
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.metricMeta {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  margin-top: auto;
  padding-top: var(--sp-1);
}

.metricModel {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-sky-dim);
}

.metricCalcBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.12s;
  margin-left: auto;
}
.metricCalcBtn:hover { background: rgba(56,189,248,0.16); }

.metricDefToggle {
  background: none;
  border: none;
  padding: 0;
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  cursor: pointer;
  text-align: left;
  transition: color 0.12s;
  margin-top: var(--sp-1);
}
.metricDefToggle:hover { color: var(--color-text-muted); }

.metricDef {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding-top: var(--sp-2);
  border-top: 1px solid var(--color-border);
}

.metricDefDesc {
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.metricDefSql {
  display: block;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--sp-2) var(--sp-3);
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.6;
}

.metricsRefreshing {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  letter-spacing: 1px;
}

.staleRow {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding-top: var(--sp-1);
  border-top: 1px solid var(--color-border);
}

.metricStale,
.chartStale {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-warn);
  line-height: 1.4;
  flex: 1;
}

.fixAiBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: var(--radius-sm);
  background: rgba(245,158,11,0.08);
  border: 1px solid rgba(245,158,11,0.25);
  color: var(--color-warn);
  cursor: pointer;
  transition: background 0.12s;
  flex-shrink: 0;
}
.fixAiBtn:hover:not(:disabled) { background: rgba(245,158,11,0.18); }
.fixAiBtn:disabled { opacity: 0.6; cursor: default; }

.metricGrain {
  font-family: var(--font-mono);
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 3px;
  border: 1px solid var(--color-border);
  color: var(--color-text-faint);
}

/* ── Empty state ──────────────────────────────────────────── */
.emptyState {
  display: flex; flex-direction: column; align-items: center; gap: var(--sp-3);
  text-align: center; padding: var(--sp-12) var(--sp-8);
  border: 1px dashed var(--color-border); border-radius: var(--radius-lg);
}
.emptyStateIcon {
  font-size: 32px; color: var(--color-border-med);
  margin-bottom: var(--sp-1);
}
.emptyStateTitle {
  font-family: var(--font-mono); font-size: 14px; font-weight: 600;
  color: var(--color-text-muted);
}
.emptyStateSub {
  font-size: 13px; color: var(--color-text-faint);
  max-width: 340px; line-height: 1.6;
}
.emptyStateAction {
  font-family: var(--font-mono); font-size: 11px; font-weight: 600;
  padding: var(--sp-2) var(--sp-5); border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08); border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky); cursor: pointer; margin-top: var(--sp-2);
  transition: background 0.15s;
}
.emptyStateAction:hover { background: rgba(56,189,248,0.15); }

/* ── Pinned from chat ─────────────────────────────────────── */
.pinnedGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: var(--sp-4);
}

/* ── Expand modal ─────────────────────────────────────────── */
.expandOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}

.expandModal {
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg);
  width: min(90vw, 1100px);
  height: min(86vh, 820px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0,0,0,0.6);
}

.expandHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.expandTitle {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.expandClose {
  font-size: 11px;
  padding: 3px 8px;
  background: rgba(239,68,68,0.1);
  border: 1px solid rgba(239,68,68,0.2);
  border-radius: var(--radius-sm);
  color: var(--color-error);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s;
}
.expandClose:hover { background: rgba(239,68,68,0.22); }

.expandBody {
  flex: 1;
  min-height: 0;
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.expandText {
  font-size: 14px;
  color: var(--color-text-muted);
  line-height: 1.7;
  overflow-y: auto;
  height: 100%;
}

/* ── Pinned cards ─────────────────────────────────────────── */
.pinnedCard {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  position: relative;
  transition: border-color 0.15s, opacity 0.15s, box-shadow 0.15s;
}

.draggable { cursor: grab; }
.draggable:active { cursor: grabbing; }
.dragging { opacity: 0.4; }
.dragOver {
  border-color: var(--color-sky) !important;
  box-shadow: 0 0 0 1px var(--color-sky);
}

.expandBtn {
  font-size: 13px;
  padding: 1px 5px;
  background: transparent;
  border: none;
  color: var(--color-text-faint);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.12s, color 0.12s;
  flex-shrink: 0;
  line-height: 1;
}
.pinnedCard:hover .expandBtn { opacity: 1; }
.expandBtn:hover { color: var(--color-sky); }

.pinnedHeader {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}

.pinnedIcon {
  font-size: 13px;
  color: var(--color-sky);
  flex-shrink: 0;
}

.pinnedTitle {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pinnedTime {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  flex-shrink: 0;
}

.pinnedContent {
  font-size: 13px;
  color: var(--color-text-muted);
  line-height: 1.6;
}

.pinnedExpand {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  background: transparent;
  align-self: flex-start;
  letter-spacing: 0.3px;
}

.pinnedExpand:hover { color: var(--color-sky); }

.pinnedChartContainer {
  width: 100%;
  min-height: 260px;
  margin-top: 4px;
}

.pinnedChartFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  margin-top: -4px;
}

.modelBadge {
  background: rgba(6, 182, 212, 0.08);
  border: 1px solid rgba(6, 182, 212, 0.2);
  color: #06b6d4;
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 10px;
  font-family: var(--font-mono);
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.syncModelBtn {
  background: none;
  border: 1px solid rgba(6, 182, 212, 0.25);
  color: #06b6d4;
  border-radius: 3px;
  padding: 1px 6px;
  font-size: 10px;
  font-family: var(--font-mono);
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.15s;
}
.syncModelBtn:hover:not(:disabled) { opacity: 1; }
.syncModelBtn:disabled { opacity: 0.4; cursor: default; }

.removeBtn {
  position: absolute; top: var(--sp-3); right: var(--sp-3);
  background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.2);
  color: var(--color-error); border-radius: var(--radius-sm);
  font-size: 10px; padding: 1px 5px; cursor: pointer; line-height: 1.4;
  transition: background 0.15s;
}
.removeBtn:hover { background: rgba(239,68,68,0.2); }

.metricActions {
  display: flex; align-items: center; gap: var(--sp-1); margin-left: auto;
}

.metricRemoveBtn {
  background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.2);
  color: var(--color-error); border-radius: var(--radius-sm);
  font-size: 10px; padding: 1px 5px; cursor: pointer; line-height: 1.4;
  transition: background 0.15s;
}
.metricRemoveBtn:hover { background: rgba(239,68,68,0.2); }

.confirmDeleteBtn {
  font-family: var(--font-mono); font-size: 10px; font-weight: 600;
  padding: 1px 6px; border-radius: var(--radius-sm);
  background: rgba(239,68,68,0.12); border: 1px solid rgba(239,68,68,0.35);
  color: var(--color-error); cursor: pointer;
  transition: background 0.15s;
}
.confirmDeleteBtn:hover:not(:disabled) { background: rgba(239,68,68,0.2); }
.confirmDeleteBtn:disabled { opacity: 0.5; cursor: default; }

.cancelDeleteBtn {
  font-family: var(--font-mono); font-size: 10px;
  padding: 1px 6px; border-radius: var(--radius-sm);
  background: transparent; border: 1px solid var(--color-border);
  color: var(--color-text-muted); cursor: pointer;
  transition: color 0.15s;
}
.cancelDeleteBtn:hover { color: var(--color-text); }
